import { Component } from "@angular/core";

@Component({
        standalone: false,
    templateUrl: "./view.component.html",
})
export class ClosedAccessComponent {}
